var _g;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgIconClock = function SvgIconClock(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#B0B5C4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.923 0C4.003 0 0 4.003 0 8.923s4.003 8.923 8.923 8.923 8.923-4.003 8.923-8.923S13.843 0 8.923 0zm0 15.947a7.032 7.032 0 0 1-7.025-7.024 7.032 7.032 0 0 1 7.025-7.024 7.032 7.032 0 0 1 7.024 7.024 7.032 7.032 0 0 1-7.024 7.024z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.573 8.647h-4.01V3.826a.735.735 0 0 0-1.47 0v5.556c0 .406.33.735.735.735h4.745a.735.735 0 0 0 0-1.47z"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-clock.b4600b41.svg";
export { ForwardRef as ReactComponent };